import { ReactNode } from 'react';

export interface TooltipProps {
  text: string;
  children: ReactNode;
}
const Tooltip = ({ text, children }: TooltipProps) => (
  <div className="group relative inline-block">
    {children}
    <span className="absolute top-full z-10 mt-1 -ml-20 hidden w-max max-w-xs rounded-sm bg-muted-white py-2 px-4 text-left font-normal hover:opacity-100 group-hover:block dark:bg-design-black-accent dark:text-white">
      {text}
    </span>
  </div>
);

export default Tooltip;
